import { useRef, useState } from "react";
import JenisMobilEdit from "./jenis-mobil-edit";
import JenisMobilList from "./jenis-mobil-list";

const JenisMobilMain = (props, { className }) => {
  const listRef = useRef(null);

  const [visibleEditorDialog, setVisibleEditorDialog] = useState(false);
  const [editorData, setEditorData] = useState(null);

  // handle ui event section

  const handleOnClickRowEdit = (row) => {
    setEditorData(row);
    setVisibleEditorDialog(true);
  };

  const handleOnConfirmedEdit = (data) => {
    listRef.current.handleOnUpdateViewRow(data);
    setVisibleEditorDialog(false);
  };

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <JenisMobilEdit
        visible={visibleEditorDialog}
        onHide={() => setVisibleEditorDialog(false)}
        editorData={editorData}
        onConfirmed={handleOnConfirmedEdit}
      />

      <JenisMobilList ref={listRef} onClickRowEdit={handleOnClickRowEdit} />
    </div>
  );
};

export default JenisMobilMain;
